import { render, staticRenderFns } from "./List04.vue?vue&type=template&id=76d13087&scoped=true&"
import script from "./list04.js?vue&type=script&lang=js&"
export * from "./list04.js?vue&type=script&lang=js&"
import style0 from "./List04.vue?vue&type=style&index=0&id=76d13087&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d13087",
  null
  
)

export default component.exports